export enum Reason {
    WORKING_CAPITAL = 'Capital de Giro',
    EQUIPMENT_PURCHASE = 'Compra de Equipamentos',
    STOCK_PURCHASE = 'Compra de Estoque',
    DEBT_CONSOLIDATION = 'Consolidação de Dívidas',
    EXPANSION = 'Expansão',
    MARKETING_AND_SALES = 'Marketing e Vendas',
    RENOVATION = 'Reforma',
    PERSONAL_USE = 'Uso Pessoal',
    OTHER = 'Outros',
};

export enum BorrowerRelationship {
    PARTNER = 'Sócio e/ou Dono',
    ADMINISTRATOR = 'Administrador e/ou Diretor',
    ATTORNEY = 'Procurador',
    OTHERS = 'Outros',
};

export enum NavSection  {
    REQUEST = 'pedido',
    INFORMATION = 'seus dados',
    CONFIRMATION = 'confirmação',
    COMPLETE = 'conclusão',
    IDENTITY = 'identificação',
};
